import { BaseEntity } from '../../models';
import { itemTipoAtivo } from './situacao';

export class ItemTipo implements BaseEntity {
    id: number;
    idEmpresa: number;
    codigo: number;
    nome: string;
    situacao: number;

    // Integração
    codigoIntegracaoErp: string;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    constructor() {
        this.situacao = itemTipoAtivo.id;
    }
}
